module.exports = __webpack_public_path__ + "img/Weapon_107.1275f6c0.png";